import Admin from "./Components/AdminComponent/admin"
import Home from "./Components/HomeComponent/home"
import Interface from "./Components/UiComponent/ui"
import VirtualFarmerPortal from "./Components/VirtualFarmerPortal/VirtualFarmerPortal"
import FeederImpressum from "./Components/Legal/FeederImpressum"
import FeederLanding, { FeederGuide, FeederArticle, FeederTwinPage } from "./Components/FeederLanding/FeederLanding"
import "./App.css"

import { BrowserRouter, Route } from "react-router-dom"

const routerBasename = window.location.pathname.startsWith("/casa-giu") ? "/casa-giu" : ""
const virtualFarmerAtRoot = ["feeder.at", "www.feeder.at"].includes(window.location.hostname)

function App() {
     return (
          <BrowserRouter basename={routerBasename}>
               <Route exact path="/" component={virtualFarmerAtRoot ? FeederLanding : Interface} />
               <Route exact path="/feeder" component={FeederLanding} />
               <Route exact path="/anmelden" component={VirtualFarmerPortal} />
               <Route exact path="/ratgeber" component={FeederGuide} />
               <Route exact path="/blog" component={FeederGuide} />
               <Route exact path="/post/:slug" component={FeederArticle} />
               <Route exact path="/digital-twin" component={FeederTwinPage} />
               <Route exact path="/admin" component={Admin} />
               <Route exact path="/home" component={Home} />
               <Route exact path="/ui" component={Interface} />
               <Route exact path="/farmer" component={VirtualFarmerPortal} />
               <Route exact path="/virtual-farmer" component={VirtualFarmerPortal} />
               <Route exact path="/impressum" component={FeederImpressum} />
               <Route exact path="/:cameraPage(\\d+)" component={Interface} />
          </BrowserRouter>
     )
}

export default App
